(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function formatYen(cents) {
      return '¥' + Math.floor(cents / 100).toLocaleString('ja-JP');
    }
    function makeBoxId() {
      var chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
      var id = '';
      for (var i = 0; i < 5; i++) id += chars.charAt(Math.floor(Math.random() * chars.length));
      return id;
    }

    function initBundle(root) {
      if (root.dataset.bundleReady) return;
      root.dataset.bundleReady = 'true';

      var boxName = root.dataset.boxName || 'えらべる詰め合わせBOX';
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-item]'));
      var sizeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-size]'));
      var linesEl = root.querySelector('[data-bundle-lines]');
      var slotsEl = root.querySelector('[data-bundle-slots]');
      var barSlotsEl = root.querySelector('[data-bundle-bar-slots]');
      var boxEl = root.querySelector('[data-bundle-box]');
      var errorEl = root.querySelector('[data-bundle-error]');
      var submitBtns = root.querySelectorAll('[data-bundle-submit]');
      var size = parseInt(root.dataset.defaultSize, 10) || 3;
      if (!sizeBtns.some(function (b) { return parseInt(b.dataset.bundleSize, 10) === size; }) && sizeBtns[0]) {
        size = parseInt(sizeBtns[0].dataset.bundleSize, 10);
      }
      // 箱に入れた順番（マス目の表示順）。同じ商品は複数回入る
      var picks = [];

      function itemById(id) {
        return items.filter(function (el) { return el.dataset.variantId === id; })[0];
      }
      function countOf(id) {
        return picks.filter(function (p) { return p === id; }).length;
      }
      function totalPrice() {
        return picks.reduce(function (sum, id) { return sum + parseInt(itemById(id).dataset.price, 10); }, 0);
      }
      function showError(msg) { if (errorEl) errorEl.textContent = msg; }

      function add(id) {
        var el = itemById(id);
        if (!el || el.dataset.available !== 'true') return;
        if (picks.length >= size) {
          showError('箱がいっぱいです。サイズを大きくするか、中身を入れ替えてください。');
          return;
        }
        picks.push(id);
        showError('');
        render(true);
      }
      function remove(id) {
        var i = picks.lastIndexOf(id);
        if (i > -1) picks.splice(i, 1);
        showError('');
        render();
      }
      function removeAll(id) {
        picks = picks.filter(function (p) { return p !== id; });
        render();
      }

      function slotHtml(id, index, animate) {
        if (!id) return '<span class="ep-bundle__slot is-empty"><span>' + (index + 1) + '</span></span>';
        var el = itemById(id);
        return '<span class="ep-bundle__slot is-filled' + (animate ? ' is-new' : '') + '" title="タップで箱から出す">' +
          (el.dataset.image ? '<img src="' + el.dataset.image + '" alt="">' : '') + '</span>';
      }

      function render(justAdded) {
        var count = picks.length;
        var full = count === size;
        var over = count > size;

        sizeBtns.forEach(function (b) {
          var active = parseInt(b.dataset.bundleSize, 10) === size;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-checked', active ? 'true' : 'false');
        });
        root.querySelectorAll('[data-bundle-size-label]').forEach(function (n) { n.textContent = '（' + size + '個入り）'; });

        // 商品カード
        items.forEach(function (el) {
          var q = countOf(el.dataset.variantId);
          el.querySelector('[data-bundle-qty]').textContent = q;
          el.classList.toggle('is-selected', q > 0);
          el.querySelector('[data-bundle-minus]').disabled = q === 0;
          if (el.dataset.available === 'true') el.querySelector('[data-bundle-plus]').disabled = count >= size;
          var badge = el.querySelector('[data-bundle-badge]');
          if (badge) { badge.hidden = q === 0; badge.textContent = '箱に' + q + '個'; }
        });

        // 箱のマス目
        var slots = '';
        var barSlots = '';
        var slotCount = Math.max(size, count);
        for (var i = 0; i < slotCount; i++) {
          slots += slotHtml(picks[i], i, justAdded && i === count - 1);
          barSlots += '<i class="' + (picks[i] ? 'is-filled' : '') + '"></i>';
        }
        slotsEl.innerHTML = slots;
        slotsEl.style.setProperty('--slots', size <= 3 ? size : Math.ceil(size / 2));
        if (barSlotsEl) barSlotsEl.innerHTML = barSlots;
        boxEl.classList.toggle('is-full', full);

        // 中身の一覧
        linesEl.innerHTML = '';
        var seen = [];
        picks.forEach(function (id) {
          if (seen.indexOf(id) > -1) return;
          seen.push(id);
          var el = itemById(id);
          var q = countOf(id);
          var li = document.createElement('li');
          li.className = 'ep-bundle__line';
          li.innerHTML =
            '<span class="ep-bundle__line-title"></span>' +
            '<span class="ep-bundle__line-qty">×' + q + '</span>' +
            '<span class="ep-bundle__line-price">' + formatYen(q * parseInt(el.dataset.price, 10)) + '</span>' +
            '<button type="button" class="ep-bundle__line-remove" data-bline-remove aria-label="箱から出す">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg></button>';
          li.querySelector('.ep-bundle__line-title').textContent = el.dataset.title;
          li.querySelector('[data-bline-remove]').addEventListener('click', function () { removeAll(id); });
          linesEl.appendChild(li);
        });

        var progress;
        if (over) progress = (count - size) + '個多く入っています。中身を減らしてください';
        else if (full) progress = '箱がいっぱいになりました';
        else if (count === 0) progress = 'あと' + size + '個、好きなベリーを選んでください';
        else progress = 'あと' + (size - count) + '個で箱がいっぱいになります';
        root.querySelectorAll('[data-bundle-progress]').forEach(function (n) { n.textContent = progress; });
        root.querySelectorAll('[data-bundle-progress-short]').forEach(function (n) { n.textContent = count + ' / ' + size + '個'; });
        root.querySelectorAll('[data-bundle-total]').forEach(function (n) { n.textContent = formatYen(totalPrice()); });

        submitBtns.forEach(function (b) { b.disabled = !full; });
        root.classList.toggle('is-full', full);
      }

      sizeBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          size = parseInt(b.dataset.bundleSize, 10);
          showError('');
          render();
        });
      });
      items.forEach(function (el) {
        var id = el.dataset.variantId;
        el.querySelector('[data-bundle-plus]').addEventListener('click', function () { add(id); });
        el.querySelector('[data-bundle-minus]').addEventListener('click', function () { remove(id); });
      });
      // 箱のマス目をタップするとその商品を1つ出す
      slotsEl.addEventListener('click', function (e) {
        var slot = e.target.closest('.ep-bundle__slot.is-filled');
        if (!slot) return;
        var index = Array.prototype.indexOf.call(slotsEl.children, slot);
        if (index > -1) { picks.splice(index, 1); render(); }
      });

      root.querySelectorAll('[data-bundle-sheet-open]').forEach(function (b) {
        b.addEventListener('click', function () { root.classList.add('is-sheet-open'); });
      });
      root.querySelectorAll('[data-bundle-sheet-close]').forEach(function (b) {
        b.addEventListener('click', function () { root.classList.remove('is-sheet-open'); });
      });

      // カートに入れる: 商品ごとに、同じ箱番号を付けて追加する
      submitBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (picks.length !== size) return;
          var boxId = makeBoxId();
          var label = boxName + '（' + size + '個入り）No.' + boxId;
          var seen = [];
          var payload = [];
          picks.forEach(function (id) {
            if (seen.indexOf(id) > -1) return;
            seen.push(id);
            payload.push({
              id: parseInt(id, 10),
              quantity: countOf(id),
              properties: { '詰め合わせ': label, '_bundle_id': boxId, '_bundle_size': String(size), '_bundle_name': boxName }
            });
          });
          submitBtns.forEach(function (b) { b.disabled = true; b.classList.add('is-loading'); });
          showError('');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: payload })
          })
            .then(function (r) {
              if (!r.ok) return r.json().then(function (e) { throw e; });
              return r.json();
            })
            .then(function () {
              picks = [];
              root.classList.remove('is-sheet-open');
              if (window.entowaCart) {
                window.entowaCart.refresh();
                window.entowaCart.open();
              } else {
                window.location.href = '/cart';
              }
            })
            .catch(function (err) {
              showError((err && err.description) || 'カートへの追加に失敗しました。在庫をご確認ください。');
            })
            .finally(function () {
              submitBtns.forEach(function (b) { b.classList.remove('is-loading'); });
              render();
            });
        });
      });

      render();
    }

    function initAll() {
      document.querySelectorAll('[data-bundle]').forEach(initBundle);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
